const MediaHeader = () => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-gray-900">
        Media Verification
      </h1>
      <p className="text-sm text-gray-500">
        Review and approve media submitted by partner stores
      </p>
    </div>
  );
};

export default MediaHeader;
